import React, { useState, useContext } from "react";
import Instance from "../../Services/Instance";
import config from "../../Services/config.js";
import SideBar from "../../Layouts/SideBar";
import { DataContext } from "../../Services/DataContext";
import "../../Assets/Styles/Products.css";
import "../../Assets/Styles/Blog.css";
import RichTextEditor from "./Components/RichTextEditor.js";

function NewFaq() {
    const { posts } = useContext(DataContext);
    const [error, setError] = useState("");
    const [newFaq, setNewFaq] = useState({
        category: "",
        title: "",
        answer: "",
        keywords: "",
        isPublished: true,
    });

    const { category, title, answer, keywords, isPublished } = newFaq;

    const onInputChange = (e) => {
        setNewFaq({ ...newFaq, [e.target.name]: e.target.value });
    };

    const onCheckboxChange = (e) => {
        setNewFaq({ ...newFaq, [e.target.name]: e.target.checked });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const keywordsArray = keywords
                ? keywords.split(",").map((k) => k.trim()).filter((k) => k)
                : [];

            await Instance.post(`${config.api_url}/faq/items`, {
                category,
                title,
                answer,
                keywords: keywordsArray,
                isPublished,
            });

            window.location = "/dashboard/faq/new-faq";
        } catch (error) {
            console.error("Erreur lors de la création de la FAQ:", error);
            setError(error);
        }
    };

    return (
        <div className="a-new-product">
            <SideBar />
            <div className="category-manager-container">
                <div className="category-manager-header">
                    <h2>Ajouter une nouvelle FAQ</h2>
                </div>

                <div className="category-manager-content">
                    <form onSubmit={handleSubmit} className="form-card">
                        <div className="form-header">
                            <h3>Informations de la FAQ</h3>
                        </div>

                        {/* Catégorie */}
                        <div className="form-group">
                            <label htmlFor="category">Catégorie</label>
                            <select
                                className="form-select"
                                value={category}
                                name="category"
                                onChange={onInputChange}
                                required
                            >
                                <option value="">Sélectionnez une catégorie</option>
                                {posts &&
                                    posts.map((cat) => (
                                        <option key={cat._id} value={cat._id}>
                                            {cat.name}
                                        </option>
                                    ))}
                            </select>
                        </div>

                        {/* Question */}
                        <div className="form-group">
                            <label htmlFor="title">Question</label>
                            <input
                                className="form-input"
                                value={title}
                                name="title"
                                type="text"
                                onChange={onInputChange}
                                required
                            />
                        </div>

                        {/* Réponse */}
                        {/*                         <div className="form-group">
                            <label htmlFor="answer">Réponse</label>
                            <textarea
                                className="form-input"
                                value={answer}
                                name="answer"
                                rows="4"
                                onChange={onInputChange}
                                required
                            />
                        </div> */}

                        <RichTextEditor
                            content={answer}
                            onChange={(html) => setNewFaq({ ...newFaq, answer: html })}
                            placeholder="Entrez la réponse détaillée..."
                        />


                        {/* Mots-clés */}
                        <div className="form-group">
                            <label htmlFor="keywords">Mots-clés (séparés par des virgules)</label>
                            <input
                                className="form-input"
                                value={keywords}
                                name="keywords"
                                type="text"
                                onChange={onInputChange}
                            />
                        </div>

                        {/* Publier */}
                        <div className="form-group">
                            <label className="form-checkbox">
                                <input
                                    type="checkbox"
                                    name="isPublished"
                                    checked={isPublished}
                                    onChange={onCheckboxChange}
                                />{" "}
                                Publier la FAQ
                            </label>
                        </div>

                        {/* Boutons */}
                        <div className="form-actions">
                            <button type="button" className="btn-cancel" onClick={() => window.history.back()}>
                                Annuler
                            </button>
                            <button type="submit" className="btn-submit">
                                Ajouter
                            </button>
                        </div>
                    </form>
                </div>

                {error && (
                    <h1 style={{ color: "red", position: "fixed", left: "10%", bottom: "10%" }}>
                        {error.response?.data?.message || "Une erreur est survenue"}
                    </h1>
                )}
            </div>
        </div>
    );
}

export default NewFaq;
